/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContractBillingCycle } from './contractBillingCycle';


export interface ArbitrageContractDetails { 
    billing_cycle?: ContractBillingCycle;
    /**
     * Payable Lease Rent
     */
    payable_lease_rent?: number;
}

